export const LEAVE_APPROVAL_ROLES = [
  { value: "reporting_manager", label: "Reporting Manager" },
  { value: "manager", label: "Manager" },
  { value: "hr", label: "HR" },
  { value: "management", label: "Management" },
  { value: "admin", label: "Admin" },
];

const normalizeWorkflowSteps = (steps, fallback) => {
  const normalized = Array.isArray(steps) ? steps : [];
  if (normalized.length === 0) return fallback;
  return normalized.map((step) => ({
    role: step.role || "reporting_manager",
    slaDays: Number(step.slaDays) || 3,
    notifyOnly: !!step.notifyOnly,
  }));
};

export const defaultLeaveGroupWorkflow = () => ({
  approvalMethod: "workflow",
  needWorkflowSteps: false,
  reminderDays: 7,
  workflowParallelApproval: false,
  workflowEscalationAfterDays: 3,
  workflowAutoApprovalIfNoAction: false,
  workflowRejectionWithReason: true,
  workflowReinitiationAllowed: true,
  workflowSteps: [
    { role: "reporting_manager", slaDays: 3, notifyOnly: false },
    { role: "hr", slaDays: 3, notifyOnly: false },
    { role: "management", slaDays: 3, notifyOnly: false },
  ],
  cancellationWorkflowSteps: [
    { role: "reporting_manager", slaDays: 3, notifyOnly: false },
    { role: "hr", slaDays: 3, notifyOnly: false },
    { role: "management", slaDays: 3, notifyOnly: false },
  ],
});

export const isSeparateWorkflowEnabled = (approval = {}) =>
  approval.enableSeparateWorkflow === true ||
  approval.enableSeparateWorkflow === "Yes";

export const defaultApprovalWorkflow = () => ({
  enableSeparateWorkflow: "No",
  ...defaultLeaveGroupWorkflow(),
});

export function normalizeLeaveTypeApprovalWorkflow(raw = {}) {
  const base = defaultApprovalWorkflow();
  const merged = { ...base, ...raw };
  merged.enableSeparateWorkflow = isSeparateWorkflowEnabled(merged) ? "Yes" : "No";
  merged.workflowSteps = normalizeWorkflowSteps(merged.workflowSteps, base.workflowSteps);
  merged.cancellationWorkflowSteps = normalizeWorkflowSteps(
    merged.cancellationWorkflowSteps,
    base.cancellationWorkflowSteps
  );
  return merged;
}

export function normalizeLeaveGroupWorkflow(raw = {}) {
  const base = defaultLeaveGroupWorkflow();
  const merged = { ...base, ...raw };
  merged.workflowSteps = normalizeWorkflowSteps(merged.workflowSteps, base.workflowSteps);
  merged.cancellationWorkflowSteps = normalizeWorkflowSteps(
    merged.cancellationWorkflowSteps,
    base.cancellationWorkflowSteps
  );
  return merged;
}

export function normalizeApprovalWorkflow(raw = {}) {
  return normalizeLeaveTypeApprovalWorkflow(raw);
}

export function mapLeaveRequestApiToInsight(row) {
  if (!row) return null;
  const statusMap = {
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    cancelled: "Cancelled",
  };
  return {
    id: `leave_req_${row.id}`,
    requestId: row.id,
    action: "Leave Request",
    employeeCode: row.employeeCode || "",
    employeeName: row.employeeName || "",
    employeeId: row.employeeId,
    status: statusMap[row.status] || row.status || "Pending",
    pendingAt: row.pendingAt || "-",
    pendingRole: row.pendingRole || null,
    canAct: row.canAct === true,
    submittedAt: row.submittedAt
      ? new Date(row.submittedAt).toLocaleString()
      : "",
    formData: row.formData || {},
    approvals: row.approvals || [],
    workflowSnapshot: row.workflowSnapshot || null,
  };
}

export function roleLabel(role) {
  return LEAVE_APPROVAL_ROLES.find((r) => r.value === role)?.label || role;
}
